import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  notification,
  Radio,
  Row,
  Select,
} from "antd"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { CloseOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons"
import Upload, { RcFile } from "antd/lib/upload"
import styles from "../filing.module.css"
import axios from "axios"
import { PreviewImgOrPdf } from "../Preview"
import { AXIOS_IP, beforeUploadFile, beforeUploadFileAndImage, customRequest } from "../fileUploadService"
import { selectCredentials } from "../../../app/applicationSlice"

export const DJDPFormModal = (props: {
  visible: boolean
  token: string
  id?: number
  memo?: string
  onOk: () => void
  onCancel: () => void
}) => {
  const credentials: any = useSelector(selectCredentials)
  
  const [form] = Form.useForm()

  const [fileList, setFileList] = useState<any>([])

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const [submitVisible, setSubmitVisible] = useState(false)

  const [isClient, setIsClient] = useState(true)

  //参考模板
  const templateData = {
    fileConfigId: "5",
    fileName: "参考模板",
    fileType: "application/pdf",
    filePath:
      "68e0cfd54adf77575a83a2b739bf5ddfa207356d866e9e74b8236c4b070475f8",
  }

  // 自定义上传实现
  const customRequestFn = (options: any, type: string) => {
    customRequest(options, AXIOS_IP, (data: any) => {
      const newurl = {
        fileConfigId: data?.configId,
        fileName: data?.name,
        fileType: data?.type,
        filePath: data?.path,
      }
      switch (type) {
        case "DJ":
          setFileList([...fileList, newurl])
          break
      }
    })
  }

  const handleRemove = (type: string, index: number) => {
    switch (type) {
      case "DJ":
        setFileList(fileList?.filter((v: any, i: number) => i !== index))
        break
    }
  }
  
  const getData = () => {
      axios({
        url: `${AXIOS_IP}/filingReviewDecoction/detail`,
        headers: {
          "Content-Type": "application/json",
          "His-Auth": props.token,
        },
        withCredentials: false,
        method: "POST",
        data: { id: props.id },
      }).then((res) => {
        const data = res.data.data
        form.setFieldsValue({
          ...data
        })
        setIsClient(data?.isClient === 1)
        setFileList(data?.clientDecoctionUrl || [])
    }).catch((err) => { console.error(err) })
  }
  

  useEffect(() => {
    form.setFieldsValue({
      clientDecoctionUrl: fileList,
    })
  }, [fileList])

  useEffect(() => {
    if (!props.visible) {
      form.resetFields()
      setFileList([])
      setIsClient(true)
    } else {
      if(props.id) {
        getData()
      }
    }
  }, [props.visible, props.id])
  return (
    <>
      <Modal
        title="中药代煎代配管理"
        width={1000}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={form.submit}
        okText="提交"
        centered
        maskClosable={false}
        confirmLoading={confirmLoading}
      >
        <div>
          <Form
            form={form}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            style={{ paddingRight: 10 }}
            initialValues={{
              isClient: 1
            }}
            onFinish={(vs) => {
              setSubmitVisible(true)
            }}
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  name="isClient"
                  label="是否委托第三方代煎代配"
                  rules={[{ required: true }]}
                >
                  <Radio.Group onChange={(e) => setIsClient(e.target.value === 1)}>
                    <Radio value={1}>是</Radio>
                    <Radio value={0}>否</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              {isClient ? <>
                <Col span={24}>
                  <Form.Item
                    name="clientOrgName"
                    label="委托方机构名称"
                    rules={[{ required: true }]}
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="clientName"
                    label="委托方联系人姓名"
                    rules={[{ required: true }]}
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="clientPhone"
                    label="委托方联系方式"
                    rules={[{ required: true }]}
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="委外代煎协议"
                    name="clientDecoctionUrl"
                    rules={[{ required: true, message: "请上传委托代煎协议" }]}
                  >
                    <Row align="middle">
                      <Upload
                        customRequest={(options) =>
                          customRequestFn(options, "DJ")
                        }
                        beforeUpload={(file) => beforeUploadFileAndImage(file, fileList)}
                        showUploadList={false}
                        maxCount={1}
                        accept={".pdf,.jpg,.jpeg,.png,.gif"}
                      >
                        <Button icon={<PlusOutlined />}>上传</Button>
                      </Upload>
                      <span style={{ padding: "0 10px 0 15px" }}>
                        支持pdf和图片文件格式上传
                      </span>
                      {/* <a
                        style={{ textDecoration: "underline", paddingRight: 10 }}
                        onClick={() => setPreviewFile(templateData)}
                      >
                        参考模板
                      </a> */}
                      {fileList?.length > 0 &&
                        fileList?.map((v: any, index: number) => {
                          return (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                paddingRight: 10,
                              }}
                            >
                              <span style={{ paddingRight: 10 }}>
                                {v.fileName}{" "}
                                <a
                                  style={{ paddingLeft: 10 }}
                                  onClick={() => setPreviewFile(v)}
                                >
                                  查看
                                </a>
                              </span>
                              <CloseOutlined
                                style={{
                                  position: "relative",
                                  top: 2,
                                  color: "rgb(161 161 161)",
                                }}
                                onClick={() => {
                                  handleRemove("DJ", index)
                                }}
                              />
                            </div>
                          )
                        })}
                    </Row>
                  </Form.Item>
                </Col>
              </> : ''}
            </Row>
          </Form>
        </div>
      </Modal>

      <Modal
        title="提交申请"
        width={450}
        visible={submitVisible}
        onCancel={() => setSubmitVisible(false)}
        confirmLoading={confirmLoading}
        onOk={() => {
          setConfirmLoading(true)
          const data = {
            ...form.getFieldsValue(),
            applicantUserId: credentials.userId,
            applicantUserName: credentials.userName,
            id: props.id,
            memo: props.memo,
          }
          axios({
            url: `${AXIOS_IP}/filingReviewDecoction/createOrUpdate`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": props.token,
            },
            withCredentials: false,
            method: "POST",
            data,
          })
            .then((res) => {
              if (res.data?.data || res.data?.success) {
                setSubmitVisible(false)
                notification.success({
                  message: "操作成功",
                })
                props.onOk()
              } else {
                notification.error({
                  message: res.data?.msg || "操作失败，请稍后重试",
                })
              }
            })
            .catch(() => {
              notification.error({
                message: "请求异常，请稍后重试",
              })
            })
            .finally(() => {
              setConfirmLoading(false)
            })
        }}
        okText="确认提交"
        centered
        maskClosable={false}
      >
        <Row style={{ height: 50 }}>
          提交后请耐心等待工作人员审核
        </Row>
      </Modal>

      <PreviewImgOrPdf
        token={props.token}
        AXIOS_IP={AXIOS_IP}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
